<ng-container>
    <!-- Barras PWA -->
    <!--<app-pwa-update-bar></app-pwa-update-bar>-->
    <!-- <app-pwa-install-bar></app-pwa-install-bar> -->
    
    <app-sidebar [class.collapsed]="!openSidebar" [isCollapsed]="!openSidebar" (toggleSidebar)="toggleSidebar()" *ngIf="mostrarSidebar"></app-sidebar>
    <div [class]="getMainContentClass()" class="main-content d-flex flex-column">
        <app-header *ngIf="mostrarSidebar"></app-header>       
        <div *ngIf="isHomologacao; else producao" class="pagina-com-marca">
            <div [class]="'marca-dagua'">HOMOLOGAÇÃO</div>
            <router-outlet></router-outlet>   
        </div>     
        <ng-template #producao>            
            <router-outlet></router-outlet>             
        </ng-template>   
        <app-footer *ngIf="mostrarSidebar"></app-footer>
    </div>
</ng-container>
  
